<template>
  <div class="zl">
    <div class="topinfo">
      <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/all/general' }"
          >概况总览</el-breadcrumb-item
        >
        <el-breadcrumb-item @click.native="isShowDetHal"
          >实时监控</el-breadcrumb-item
        >
        <el-breadcrumb-item v-if="isShowDet">回路详情</el-breadcrumb-item>
      </el-breadcrumb> -->
      <div class="ellist">
        <div
          class="item"
          v-for="(item, index) in elList"
          :key="index"
          :class="item.id === elIndex ? 'active' : ''"
          @click="elIndex = item.id"
          :title="item.roomName"
        >
          {{ item.roomName }}
        </div>
      </div>
      <div class="monitor-list">
        <div
          class="child"
          :class="activeIndex == index2 ? 'active' : ''"
          v-for="(item2, index2) in monitorList"
          :key="index2"
          @click="monitorChildClick(index2)"
        >
          {{ item2.value }}
        </div>
      </div>
    </div>
    <div class="main">
      <wenshidu v-if="activeIndex === 0"></wenshidu>
      <shuiqin v-if="activeIndex === 1"></shuiqin>
    </div>
  </div>
</template>

<script>
import wenshidu from "./component/wenshidu";
import shuiqin from "./component/shuiqin";
export default {
  components: {
    wenshidu,
    shuiqin,
  },
  data() {
    return {
      projectId: "",
      elList: [],
      elIndex: 0,
      monitorIndex: 0,
      activeIndex: 0,
      monitorList: [
        {
          value: "温湿度设备",
        },
        {
          value: "水浸设备",
        },
      ],
    };
  },
  computed: {
    isShowDet() {
      return this.$store.state.isShowDet;
    },
  },
  created() {
    // console.log(this.$getCookie("roomId"))
    // this.elIndex=Number(this.$getCookie("projectId"))
    this.projectId = this.$getCookie("projectId");
    this.searchEquipmentRoomList();
  },
  methods: {
    // 关闭显示回路详情
    isShowDetHal() {
      console.log(12);
      this.$store.commit("setIsShowDet", false);
    },
    monitorClick(index) {
      this.$set(this.monitorIndex, index);
    },
    monitorChildClick(index) {
      // this.$set(this.monitorIndex, 1, index);
      this.activeIndex = index;
    },
    searchEquipmentRoomList() {
      this.$http
        .post(
          "bma-distribution-service/equipmentRoom/searchEquipmentRoomList",
          {
            projectId: this.projectId,
          }
        )
        .then((res) => {
          if (res.code == 200) {
            this.elList = res.data;
            if (res.data.length > 0) {
              this.$getCookie("roomId")
                       ? this.$cookies.set('roomId', this.$cookies.get("roomId"), { expires: 365 })
                : this.$cookies.set('roomId', res.data[0].id, { expires: 365 });
              this.elIndex = Number(this.$getCookie("roomId"));
            }
          }
        });
    },
  },
  watch: {
    elIndex(n) {
      // alert(n+'sfopdfpdfiop'
      // console.log(o)
    this.$cookies.set('roomId', n)
      this.$store.commit("setRoomId", n);
    },
  },
};
</script>

<style lang="less" scoped>
.zl {
  position: relative;
  .topinfo {
    background: #fff;
    padding-bottom: 9px;
   width: calc(100% - 40px);
    padding: 20px 20px 0px 20px;
    box-shadow: 0px 0px 13px rgba(32, 47, 79, 0.09);
    .ellist {
      display: flex;
      margin-top: 0px;
      .item {
        width: 106px;
        height: 32px;
        margin-right: 20px;
        background: #eeeeee;
        border-radius: 5px;
        text-align: center;
        font-size: 12px;
        color: #8e9fa8;
        line-height: 32px;
        cursor: pointer;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        &.active {
          color: #fff;
          background: #1460e0;
        }
      }
    }
    .monitor-list {
      display: flex;
      margin-top: 16px;
      // .item {
      //   display: flex;
      //   > div {
      //     padding: 8px 22px;
      //     color: #0e223d;
      //     font-size: 16px;
      //     cursor: pointer;
      //   }
      // &.active {
      //   > div {
      //     color: #fff;
      //     background: #1054c6;
      .child {
        font-size: 12px;
        line-height: 20px;
        padding: 8px 22px;
        color: #0e223d;
        background: #fff;
        cursor: pointer;
      }
      .child.active {
        background: #fff;
        color: #1460e0;
        position: relative;
        &::after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 22px;
          right: 22px;
          height: 2px;
          background: #1460e0;
        }
      }
      //     }
      //   }
      // }
    }
  }
  .main {
    margin-top: 16px;
  }
}
</style>